<template>
    <v-container class="fill-height" style="display: block;" fluid>

        <v-row v-if="!showNetworkMap">
            <v-col cols="12" sm="12" md="6" lg="4" xl="3" v-for="networkMap in networkMapsList" :key="networkMap.network_map_id">
                <v-card class="network-map-card" light style="cursor: pointer;" @click="editNetworkMap(networkMap)" height="400">
                    <v-card-title class="mb-5" style="padding-top: 5px;">{{ networkMap.network_map_name }}</v-card-title>
                    <span class="network-map-subtitle date">Last modified on: {{ formatDate(networkMap.network_map_last_modified_on) }}</span>
                    <span class="network-map-subtitle user">By: {{ lookupUserFromUserId(networkMap.network_map_last_modified_by).user_username }}</span>
                    <v-btn class="network-map-delete" icon light x-large color="red" :disabled="lockSave" @click.stop="deleteNetworkMapClick(networkMap)"><v-icon>mdi-delete-forever</v-icon></v-btn>
                    <v-divider />
                    <v-card-text>
                        <img class="thumbnail-image" :src="networkMap.network_map_thumbnail" />
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="4" xl="3" v-if="!lockSave">
                <div class="new-network-map" @click="createNetworkMapClick">
                    <div class="create-new-container">
                        <span><v-icon x-large color="#ffffff">mdi-plus-circle</v-icon> Create New</span>
                    </div>
                </div>
            </v-col>
        </v-row>

        <network-map :networkMap="networkMap" :lockSave="lockSave" :isSaving="isSaving" @setIsSaving="isSaving = $event" v-if="showNetworkMap" @cancel="cancelNetworkMap" @save="saveNetworkMap" @locked="lockSave = true"></network-map>

    </v-container>
</template>

<script>
import NetworkMap from "@/components/NetworkMaps/NetworkMap";
export default {
    name: 'NetworkMaps',
    props: [],
    components: {
        NetworkMap
    },
    data: () => ({
        showNetworkMap: false,
        networkMapsList: [],
        networkMap: null,
        lockSave: false,
        isSaving: false
    }),

    computed: {

    },

    methods: {
        getNetworkMapsList: function() {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "networkmap/list");
            return this.$http.get(route).then(response => {
                let results = response.body;
                this.networkMapsList = results;
                TELSA.loading(false);
            });
        },

        createNetworkMapClick: function() {
            this.networkMap = {
                network_map_id: 0,
                network_map_name: 'New Network Map',
                network_map_thumbnail: null,
                network_map_data: null,
            }
            this.showNetworkMap = true;
        },

        editNetworkMap: function(networkMap) {
            let route = `${TELSA.apiHost}networkmap/${networkMap.network_map_id}`;
            return this.$http.get(route).then(response => {
                let results = response.body;
                networkMap.network_map_data = results.network_map_data;
                this.networkMap = networkMap;
                this.showNetworkMap = true;
            });
        },

        saveNetworkMap: function(networkMapData, thumbnail) {
            //TELSA.loading(true);
            this.isSaving = true;
            let route = (TELSA.apiHost + "networkmap/edit");
            if(this.networkMap.network_map_id == 0) {
                route = (TELSA.apiHost + "networkmap/add");
            }
            this.networkMap.network_map_data = networkMapData;
            this.networkMap.network_map_thumbnail = thumbnail;
            return this.$http.post(route, {args: {networkMap: this.networkMap}}).then(response => {
                let result = response.body;
                //this.showNetworkMap = false;
                //this.networkMap = null;
                this.$store.commit('setIsDirty', false);
                //this.$store.dispatch('handleRemoveLocks');
                //this.getNetworkMapsList();
                console.log('saving complete!');
                this.isSaving = false;
            });
        },

        cancelNetworkMap: function() {
            this.showNetworkMap = false;
            this.networkMap = null;
            this.$store.commit('setIsDirty', false);
            this.$store.dispatch('handleRemoveLocks');
        },

        deleteNetworkMapClick: function(networkMap) {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Delete',
                message: `Are you sure you want to delete <b>${networkMap.network_map_name}</b> network map?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteNetworkMap(networkMap)
            });
        },
        deleteNetworkMap: function(networkMap) {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "networkmap/delete");
            return this.$http.post(route, {args: {networkMapId: networkMap.network_map_id}}).then(response => {
                let result = response.body;
                this.getNetworkMapsList();
            });
        },

        formatDate: function(date) {
            return TELSA.moment(date).format('YYYY-MM-DD HH:mm');
        },

        lookupUserFromUserId: function(userId) {
            return this.$store.state.batchConfig.users.find(user => {
                return (user.user_id == userId);
            });
        },

    },

    mounted() {
        // Permissions Check
        let self = this;
        let permission = TELSA.checkPermission(this.$store.state.user, 'admin/network-map');
        if(!permission) {
            this.$store.commit('insufficientPermissions', {
                confirmAction: function(){self.getNetworkMapsList();}
            });
            this.lockSave = true;
            return;
        }
        this.getNetworkMapsList();
    }

  
};
</script>

<style scoped>

    .network-map-card:hover {
        margin-top: -10px !important;
        transition: all 0.3s;
    }

    .thumbnail-image {
        max-width: 100%;
        /* border: black solid 1px; */
    }

    .network-map-subtitle {
        display: block;
        font-size: 12px;
        text-transform: uppercase;
        font-weight: bold;
        position: absolute;
        left: 16px;
    }
    .network-map-subtitle.date {
        top: 32px;
    }
    .network-map-subtitle.user {
        top: 48px;
    }

    .network-map-delete {
        display: block;
        position: absolute;
        top: 10px;
        right: 15px;
    }

    .new-network-map {
        display: block;
        position: relative;
        border: #ffffff dashed 1px;
        height: 400px;
        border-radius: 4px;
        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
        text-align: center;
        cursor: pointer;
    }

    .new-network-map .create-new-container {
        position: relative;
        display: block;
        cursor: pointer;
        color: #ffffff;
        font-size: 34px;
        border-radius: 4px;
        margin-top: calc((400px / 2) - 25px);
        transition: all 0.3s;
    }
    .new-network-map:hover .create-new-container {
        font-size: 44px;
        transition: all 0.3s;
    }

</style>
